import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import "moment/locale/es"; //
import {  Paper, /* IconButton, Avatar, */ Typography } from "@material-ui/core";
import red from '@material-ui/core/colors/red';
// import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
// import {useDispatch} from 'react-redux';
//import { startDeletingObservacion } from "../../actions/observaciones";
const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },

  title: {
    fontSize: 14,
    padding: 10,
  },
  pos: {
    marginBottom: 12,
  },
  container: {
    margin: 10,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  contenidoTexto: {
    fontSize: 14,
    padding: 2,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  texto: {
    fontSize: 14,
    padding: 12,
  },
  iconoTrash: {
    color: "#fff",
    backgroundColor: red[500],
    marginTop: 35,
    marginRight: 35,
  },
});
export const ObservacionItemPreafiliado = ({ item }) => {
  const classes = useStyles();
 
  return (
    <Paper className={classes.container}>
      <div>
        <div className={classes.contenidoTexto}>
          <Typography
            className={classes.title}
            color="textSecondary"
            gutterBottom
          >
            {item.usuario.userName}
          </Typography>
          <Typography className={classes.title} color="primary" gutterBottom>
            {moment(item.fecha).format("LLLL")}
          </Typography>
        </div>
        <div>
          <Typography variant="h6" className={classes.texto} component="p">
            {item.mensaje}
          </Typography>
        </div>
      </div>
    </Paper>
  );
};
